import "./Dashboard.scss";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/Sidebar/Sidebar";
import MobileNav from "../../components/MobileNav/MobileNav";

const Index = () => {
  return (
    <div className="dashboard">
      <div className="dashboard__sidebar">
        <Sidebar />
      </div>
      <div className="dashboard__content">
        <MobileNav />
        <Outlet />
      </div>
    </div>
  );
};

export default Index;